import _definePage_default_0 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/index.vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/adoptions/index.vue?definePage&vue'
import _definePage_default_3 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/index.vue?definePage&vue'
import _definePage_default_4 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/supply/index.vue?definePage&vue'
import _definePage_default_5 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/upload/index.vue?definePage&vue'
import _definePage_default_6 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/catalog-search/index.vue?definePage&vue'
import _definePage_default_7 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/courses/index.vue?definePage&vue'
import _definePage_default_8 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/reports/index.vue?definePage&vue'
import _definePage_default_9 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/requests/index.vue?definePage&vue'
import _definePage_default_10 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/requests/history/index.vue?definePage&vue'
import _definePage_default_11 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/requests/purchase/index.vue?definePage&vue'
import _definePage_default_12 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/search/request.vue?definePage&vue'
import _definePage_default_13 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/index.vue?definePage&vue'
import _definePage_default_14 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/configuration.vue?definePage&vue'
import _definePage_default_15 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/courses.vue?definePage&vue'
import _definePage_default_16 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/financial-aid.vue?definePage&vue'
import _definePage_default_17 from '/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/students/index.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/',
    name: '/',
    component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/index.vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/:404(.*)',
    name: '/[...404]',
    component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/[...404].vue'),
    /* no children */
    meta: {
      "layout": "unauthenticated"
    }
  },
  {
    path: '/adoptions',
    /* internal name: '/adoptions' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/adoptions/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/adoptions/index.vue'),
        /* no children */
      },
  _definePage_default_2
  )
    ],
  },
  {
    path: '/analytics',
    /* internal name: '/analytics' */
    /* no component */
    children: [
      {
        path: ':dashboardId',
        name: '/analytics/[dashboardId]',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/analytics/[dashboardId].vue'),
        /* no children */
        meta: {
          "requiresAuth": true,
          "featureFlag": "dashboards"
        }
      }
    ],
  },
  {
    path: '/booklist',
    /* internal name: '/booklist' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/booklist/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/index.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
      {
        path: 'supply',
        /* internal name: '/booklist/supply' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/booklist/supply/',
            component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/supply/index.vue'),
            /* no children */
          },
  _definePage_default_4
  )
        ],
      },
      {
        path: 'upload',
        /* internal name: '/booklist/upload' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/booklist/upload/',
            component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/upload/index.vue'),
            /* no children */
          },
  _definePage_default_5
  ),
          {
            path: ':uploadId',
            name: '/booklist/upload/[uploadId]',
            component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/booklist/upload/[uploadId].vue'),
            /* no children */
            meta: {
              "requiresAuth": true,
              "fixed": true
            }
          }
        ],
      }
    ],
  },
  {
    path: '/catalog-search',
    /* internal name: '/catalog-search' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/catalog-search/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/catalog-search/index.vue'),
        /* no children */
      },
  _definePage_default_6
  )
    ],
  },
  {
    path: '/courses',
    /* internal name: '/courses' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/courses/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/courses/index.vue'),
        /* no children */
      },
  _definePage_default_7
  )
    ],
  },
  {
    path: '/reports',
    /* internal name: '/reports' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/reports/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/reports/index.vue'),
        /* no children */
      },
  _definePage_default_8
  )
    ],
  },
  {
    path: '/requests',
    /* internal name: '/requests' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/requests/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/requests/index.vue'),
        /* no children */
      },
  _definePage_default_9
  ),
      {
        path: 'history',
        /* internal name: '/requests/history' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/requests/history/',
            component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/requests/history/index.vue'),
            /* no children */
          },
  _definePage_default_10
  )
        ],
      },
      {
        path: 'purchase',
        /* internal name: '/requests/purchase' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: '',
            name: '/requests/purchase/',
            component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/requests/purchase/index.vue'),
            /* no children */
          },
  _definePage_default_11
  )
        ],
      }
    ],
  },
  {
    path: '/search',
    /* internal name: '/search' */
    /* no component */
    children: [
      {
        path: ':nbsi',
        name: '/search/[nbsi]',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/search/[nbsi].vue'),
        /* no children */
      },
  _mergeRouteRecord(
      {
        path: 'request',
        name: '/search/request',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/search/request.vue'),
        /* no children */
      },
  _definePage_default_12
  )
    ],
  },
  {
    path: '/store',
    /* internal name: '/store' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/store/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/index.vue'),
        /* no children */
      },
  _definePage_default_13
  ),
  _mergeRouteRecord(
      {
        path: 'configuration',
        name: '/store/configuration',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/configuration.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
  _mergeRouteRecord(
      {
        path: 'courses',
        name: '/store/courses',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/courses.vue'),
        /* no children */
      },
  _definePage_default_15
  ),
  _mergeRouteRecord(
      {
        path: 'financial-aid',
        name: '/store/financial-aid',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/store/financial-aid.vue'),
        /* no children */
      },
  _definePage_default_16
  )
    ],
  },
  {
    path: '/students',
    /* internal name: '/students' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '',
        name: '/students/',
        component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/students/index.vue'),
        /* no children */
      },
  _definePage_default_17
  )
    ],
  },
  {
    path: '/unauthorized',
    name: '/unauthorized',
    component: () => import('/Users/omarqureshi/repos/institutions/web/adoptions/src/pages/unauthorized.vue'),
    /* no children */
    meta: {
      "layout": "unauthenticated"
    }
  }
]
